var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-page-base",
    {
      attrs: {
        title: _vm.title,
        loading: _vm.loadingInvoices,
        "show-back": !!_vm.title
      },
      on: {
        back: function($event) {
          _vm.$router.push({ name: "invoice-audit-list" })
        }
      }
    },
    [
      _vm.invoice
        ? _c("div", [
            _c("section", { staticClass: "level invoice-audit-detail" }, [
              _vm.invoice.logistic_provider
                ? _c(
                    "div",
                    {
                      staticClass:
                        "level-item has-text-centered box invoice-audit-detail__item"
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "b-tooltip",
                            {
                              attrs: {
                                label: _vm.invoice.logistic_provider.name
                              }
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "invoice-audit-detail__logistic-provider",
                                attrs: {
                                  src: _vm.logisticProviderLogo,
                                  alt: _vm.invoice.logistic_provider.name
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.deliveryMethods.length > 0
                            ? _c("p", { staticClass: "heading" }, [
                                _vm._v(
                                  "\n            Métodos de Envio: " +
                                    _vm._s(_vm.deliveryMethodsNames) +
                                    "\n          "
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.invoice.due_date
                ? _c(
                    "div",
                    {
                      staticClass:
                        "level-item has-text-centered box invoice-audit-detail__item"
                    },
                    [
                      _c("div", [
                        _c("p", { staticClass: "heading" }, [
                          _vm._v("Data de vencimento")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "title is-5" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("date")(_vm.invoice.due_date)) +
                              "\n          "
                          )
                        ])
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "level-item has-text-centered box invoice-audit-detail__item"
                },
                [
                  _c("div", [
                    _c("p", { staticClass: "heading" }, [
                      _vm._v("Divergência")
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "span",
                        {
                          staticClass: "title is-5",
                          class: {
                            "has-text-danger": _vm.invoice.divergence_value < 0
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm._f("currency")(
                                  _vm.invoice.divergence_value || 0
                                )
                              ) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "small",
                        {
                          staticClass: "tag",
                          class: {
                            "is-success":
                              _vm.invoice.divergence_percentage >= 0,
                            "is-danger": _vm.invoice.divergence_percentage < 0
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm._f("percent")(
                                  _vm.invoice.divergence_percentage || 0
                                )
                              ) +
                              "\n            "
                          )
                        ]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "level-item has-text-centered invoice-audit-detail__item"
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "button is-primary",
                      attrs: { to: { name: "invoice-audit-new" } }
                    },
                    [_vm._v("Refazer análise de fatura")]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "box" },
              [
                _c(
                  "sc-field",
                  { attrs: { label: "Marcadores" } },
                  [
                    _c("sc-recon-markers-input", {
                      attrs: { tags: _vm.invoiceMarkers },
                      on: {
                        add: function(marker) {
                          return _vm.linkMarker(marker.id)
                        },
                        remove: function(marker) {
                          return _vm.unlinkMarker(marker.id)
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "box" },
              [
                _c(
                  "sc-tabs",
                  {
                    model: {
                      value: _vm.activeTab,
                      callback: function($$v) {
                        _vm.activeTab = $$v
                      },
                      expression: "activeTab"
                    }
                  },
                  [
                    _c(
                      "sc-tab-item",
                      { attrs: { label: "Resumo" } },
                      [_c("tab-invoice-audit-detail-resume")],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "sc-tab-item",
                      { attrs: { label: "Histórico" } },
                      [_c("tab-invoice-audit-detail-history")],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "sc-tab-item",
                      { attrs: { label: "Itens da fatura" } },
                      [_c("tab-invoice-audit-detail-order-items")],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "buttons is-right" }, [
                  _vm.invoice.result_download_url
                    ? _c(
                        "button",
                        {
                          staticClass: "button is-primary",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              _vm.downloadInvoiceFilePerUrl(
                                _vm.invoice.result_download_url
                              )
                            }
                          }
                        },
                        [_vm._v("Baixar arquivo de análise")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.invoice.result_download_url
                    ? _c(
                        "button",
                        {
                          staticClass: "button is-primary",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              _vm.generateAnalyzeFile(
                                _vm.invoice.reconciliation_invoice_id
                              )
                            }
                          }
                        },
                        [_vm._v("Gerar arquivo de análise")]
                      )
                    : _vm._e()
                ])
              ],
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0136d918", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0136d918","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/invoice-audit/pages/invoice-audit-detail/PageInvoiceAuditDetail.vue
// module id = null
// module chunks = 